export default __webpack_public_path__ + "static/1.7-Responsive-DONT-f2ec48aa8850b36f921642795d000374.png";